import {Box, Chip, Container, Divider, Link, Typography} from "@mui/material";
import {motion, useAnimation, useInView} from "framer-motion";
import {useEffect, useRef} from "react";
import {useParams} from "react-router-dom";
import LandingPage from "../LandingPage/LandingPage";

const projects = [
    {
        id: "newcastle",
        title: "NewCastle University",
        duration: '2019 - 2020',
        course: "MSc Game Engineering",
        qualification: 'Distinction',
        modules:['Advanced Programming with C++ and .NET', 'Advanced Graphics with OpenGL', 'Advanced Game Programming with Unity and Unreal.','Built and Integrated a custom game engine to work with Playstation'],
        website: 'https://www.ncl.ac.uk',
        location: 'Newcastle, UK',
        image: '/images/newcastle2.jpg',
    },
    {
        id: "leicester",
        title: "University of Leicester",
        duration: '2016 - 2019',
        course: "BSc Computer Science",
        qualification: '2:1',
        modules:['Mastered programming, data structures, algorithms, and web development.', 'Studied software engineering principles, database systems, and operating systems', 'Explored artificial intelligence, computer graphics, and game development technologies'],
        website: 'https://le.ac.uk',
        location: 'Leicester, UK',
        image: '/images/leicester2.jpg',
    },
];

const EducationSubPage = () => {
    const {id} = useParams();
    const item = projects.find(project => project.id === id);


    const ref = useRef(null);
    const controls = useAnimation();
    const isInView = useInView(ref, { once: false, amount: 0.2 }); // Detects if it's in view

    useEffect(() => {
        if (isInView) {
            controls.start({ opacity: 1, y: 0 });
        }
    }, [isInView, controls]); // Runs when the view state changes

    if (!item) {
        return <LandingPage/>;
    }

    return (
        <>
            <Container>
                <Box sx={{
                    paddingTop: '20px',
                    paddingBottom: '40px',
                    // py: 5,
                    px: {xs: 3, md: 6},
                    textAlign: "left",
                    color: "white"
                }}>
                    <motion.div
                        ref={ref}
                        transition={{duration: 0.3}}
                        initial={{ opacity: 0, y: 50 }}
                        animate={controls} // Now controlled by `useAnimation`
                        whileInView={{ opacity: 1, y: 0 }}
                    >
                        <Box sx={{display: "flex", justifyContent: "space-between"}}>
                            <Box sx={{height: '100%', alignItems: 'center'}}>
                                {/* Title & Underline */}
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontWeight: "bold",
                                        textTransform: "uppercase",
                                        fontFamily: `"Poppins", sans-serif`,
                                        display: "inline-block",
                                        fontSize: {xs: '14px', md:'24px'},
                                    }}
                                >
                                    {item.title}
                                </Typography>
                                <Divider
                                    sx={{
                                        backgroundColor: "#FFD700", // Faint Gold Underline
                                        height: "2px",
                                        width: "80px",
                                        mt: 1,
                                        mb: 4,
                                        // mx: "auto",
                                    }}
                                />
                            </Box>
                        </Box>
                        <Box>
                            <ul style={{
                                listStyle: 'none',
                                paddingLeft: '0px',
                                gap: '10px',
                            }}>
                                <li style={{paddingBottom: '10px'}}>
                                    <Chip color="success" label='Course' /> {item.course}
                                </li>
                                <li style={{paddingBottom: '10px'}}>
                                    <Chip color="success" label="Duration"/> {item.duration}
                                </li>
                                <li style={{paddingBottom: '10px'}}>
                                    <Chip color="success" label='Qualification' /> {item.qualification}
                                </li>
                                <li style={{paddingBottom: '10px'}}>
                                    <Chip color="success" label='Modules' />
                                    <ul>
                                        {item.modules.map((module, index) => (
                                            <li key={index}>
                                                {module}
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                                <li style={{paddingBottom: '10px'}}>
                                    <Chip color="success" label='Website' /> <Link href={item.website} target='_blank' rel="noreferrer"> {item.website}</Link>
                                </li>
                                <li style={{paddingBottom: '10px'}}>
                                    <Chip color="success" label='Location' /> {item.location}
                                </li>
                            </ul>
                        </Box>
                        <img src={item.image}  alt={item.title} style={{
                            width: '100%',
                        }}/>
                    </motion.div>
                </Box>
            </Container>
        </>
    )
}

export default EducationSubPage;
